import * as React from "react";
const ClothesTechnicianMale = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<defs>
			<style>
				{
					".cls-corp-mal-rep-1{fill:none;}.cls-corp-mal-rep-2{fill:#294256;}.cls-corp-mal-rep-3{clip-path:url(#clip-path-corp-mal-rep);}.cls-corp-mal-rep-4{fill:#aab4b5;}.cls-corp-mal-rep-5{fill:#f5f7f7;}.cls-corp-mal-rep-6{clip-path:url(#clip-path-corp-mal-rep-2);}.cls-corp-mal-rep-7{clip-path:url(#clip-path-corp-mal-rep-3);}.cls-corp-mal-rep-8{fill:#676268;}.cls-corp-mal-rep-9{fill:#221e23;}.cls-corp-mal-rep-10{clip-path:url(#clip-path-corp-mal-rep-4);}.cls-corp-mal-rep-11{fill:#11272d;}.cls-corp-mal-rep-12{fill:#30576d;}.cls-corp-mal-rep-13,.cls-corp-mal-rep-14{fill:#fff;}.cls-corp-mal-rep-13{stroke:#11272d;stroke-miterlimit:10;}"
				}
			</style>
			<clipPath id="clip-path-corp-mal-rep">
				<path
					className="cls-corp-mal-rep-1"
					d="M601.17,1730.25s-2.1,63-4.2,73.5-3.18,9-6.3,16.8c-4.2,10.5-6.3,27.3,0,33.6s35.7,21,67.2,18.9,48.65-12.44,50.4-16.8c4.2-10.5,0-37.8-4.2-46.2s-12.6-23.1-14.7-29.4-8.4-35.7-10.5-54.6S601.17,1730.25,601.17,1730.25Z"
				/>
			</clipPath>
			<clipPath id="clip-path-corp-mal-rep-2">
				<path
					className="cls-corp-mal-rep-1"
					d="M525.57,1730.25s2.1,63,4.2,73.5,3.18,9,6.3,16.8c4.2,10.5,6.3,27.3,0,33.6s-35.7,21-67.2,18.9-48.66-12.44-50.4-16.8c-4.2-10.5,0-37.8,4.2-46.2s12.6-23.1,14.7-29.4,8.4-35.7,10.5-54.6S525.57,1730.25,525.57,1730.25Z"
				/>
			</clipPath>
			<clipPath id="clip-path-corp-mal-rep-3">
				<path
					className="cls-corp-mal-rep-1"
					d="M718.77,900.75c0-46.2-10.5-79.8-10.5-79.8l-144.9,23.1L418.47,821s-10.5,33.6-10.5,79.8c0,37.86-6.3,329.7-4.2,344.4s10.5,63,10.5,81.9-4.2,119.7-4.2,136.5,21,264.6,21,264.6,52.5,35.7,105,0c2.1-52.5,2.1-336,0-363.3s23.1-331.8,23.1-331.8h8.4s25.2,304.5,23.1,331.8-2.1,310.8,0,363.3c52.5,35.7,105,0,105,0s21-247.8,21-264.6-4.2-117.6-4.2-136.5,8.4-67.2,10.5-81.9S718.77,938.61,718.77,900.75Z"
				/>
			</clipPath>
			<clipPath id="clip-path-corp-mal-rep-4">
				<path
					className="cls-corp-mal-rep-2"
					d="M832.17,747.45c-6.3-29.4-18.9-81.9-18.9-98.7s-23.1-176.4-27.3-195.3-21-50.4-42-63-96.6-39.9-115.5-54.6c4.2-6.3,10.5-14.7,21-12.6s-8.4-31.5-31.5-33.6v39.9a9.2,9.2,0,0,0,2.1,6.3s-21,31.5-56.7,31.5-56.7-31.5-56.7-31.5a9.2,9.2,0,0,0,2.1-6.3v-39.9c-23.1,2.1-42,35.7-31.5,33.6s16.8,6.3,21,12.6c-18.9,14.7-94.5,42-115.5,54.6s-37.8,44.1-42,63-27.3,178.5-27.3,195.3-12.6,69.3-18.9,98.7-4.2,161.7,2.1,191.1c29.4,25.2,69.3,6.3,69.3,6.3s14.7-165.9,16.8-176.4,12.6-56.7,16.8-71.4S412.17,569,412.17,569s14.7,172.2,14.7,186.9-12.6,58.8-12.6,65.1c48.3,42,149.1,39.9,149.1,39.9s100.8,2.1,149.1-39.9c0-6.3-12.6-50.4-12.6-65.1S714.57,569,714.57,569s8.4,113.4,12.6,128.1,14.7,60.9,16.8,71.4,16.8,176.4,16.8,176.4,39.9,18.9,69.3-6.3C836.37,909.15,838.47,776.85,832.17,747.45Z"
				/>
			</clipPath>
		</defs>
		<title>{"habit r\xE9parateur m"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect className="cls-corp-mal-rep-1" width={1080} height={1920} />
		</g>
		<g id="r\xE9parateur_m" data-name="r\xE9parateur m">
			<g className="cls-corp-mal-rep-3">
				<path
					className="cls-corp-mal-rep-4"
					d="M601.17,1730.25s-2.1,63-4.2,73.5-3.18,9-6.3,16.8c-4.2,10.5-6.3,27.3,0,33.6s35.7,21,67.2,18.9,48.65-12.44,50.4-16.8c4.2-10.5,0-37.8-4.2-46.2s-12.6-23.1-14.7-29.4-8.4-35.7-10.5-54.6S601.17,1730.25,601.17,1730.25Z"
				/>
				<path
					className="cls-corp-mal-rep-5"
					d="M584.37,1854.15s-6.3-21,2.1-31.5,29.4-25.2,60.9-27.3,56.7,6.3,65.1,29.4-8.4,69.3-8.4,69.3l-119.7-21Z"
				/>
				<path
					className="cls-corp-mal-rep-5"
					d="M626.37,1734.45s2.1,63-4.2,75.6,48.3-4.2,48.3-4.2-10.5-31.5-10.5-79.8C641.07,1730.25,626.37,1734.45,626.37,1734.45Z"
				/>
			</g>
			<g className="cls-corp-mal-rep-6">
				<path
					className="cls-corp-mal-rep-4"
					d="M525.57,1730.25s2.1,63,4.2,73.5,3.18,9,6.3,16.8c4.2,10.5,6.3,27.3,0,33.6s-35.7,21-67.2,18.9-48.66-12.44-50.4-16.8c-4.2-10.5,0-37.8,4.2-46.2s12.6-23.1,14.7-29.4,8.4-35.7,10.5-54.6S525.57,1730.25,525.57,1730.25Z"
				/>
				<path
					className="cls-corp-mal-rep-5"
					d="M542.37,1854.15s6.3-21-2.1-31.5-29.4-25.2-60.9-27.3-56.7,6.3-65.1,29.4,8.4,69.3,8.4,69.3l119.7-21Z"
				/>
				<path
					className="cls-corp-mal-rep-5"
					d="M500.37,1734.45s-2.1,63,4.2,75.6-48.3-4.2-48.3-4.2,10.5-31.5,10.5-79.8C485.67,1730.25,500.37,1734.45,500.37,1734.45Z"
				/>
			</g>
			<g className="cls-corp-mal-rep-7">
				<path
					className="cls-corp-mal-rep-8"
					d="M718.77,900.75c0-46.2-10.5-79.8-10.5-79.8l-144.9,23.1L418.47,821s-10.5,33.6-10.5,79.8c0,37.86-6.3,329.7-4.2,344.4s10.5,63,10.5,81.9-4.2,119.7-4.2,136.5,21,264.6,21,264.6,52.5,35.7,105,0c2.1-52.5,2.1-336,0-363.3s23.1-331.8,23.1-331.8h8.4s25.2,304.5,23.1,331.8-2.1,310.8,0,363.3c52.5,35.7,105,0,105,0s21-247.8,21-264.6-4.2-117.6-4.2-136.5,8.4-67.2,10.5-81.9S718.77,938.61,718.77,900.75Z"
				/>
				<path
					className="cls-corp-mal-rep-9"
					d="M720.87,1304s-33.6,39.9-100.8,10.5c-4.2-31.5-44.1-281.4-44.1-281.4l-8.4-4.2h-8.4l-8.4,4.2s-39.9,249.9-44.1,281.4c-67.2,29.4-100.8-10.5-100.8-10.5s-52.5,92.4,4.46,146.58,127.09,0,127.09,0l26-417.48,25.94,417.48s70.13,54.19,127.09,0S720.87,1304,720.87,1304Z"
				/>
				<path
					className="cls-corp-mal-rep-9"
					d="M609.57,852.45s12.6,31.5,69.3,27.3c48.3-21,21-63,21-63Z"
				/>
				<path
					className="cls-corp-mal-rep-9"
					d="M516.45,852.45s-12.6,31.5-69.3,27.3c-48.3-21-21-63-21-63Z"
				/>
			</g>
			<path
				className="cls-corp-mal-rep-9"
				d="M406.42,1262.28s30.95-23.43,37.25-36-8.4-176.4-8.4-176.4l-29.54-6.77s-10.36,25.67-10.36,29.87,8.4,2.1,8.4,2.1-12.6,149.1-8.4,161.7A196,196,0,0,0,406.42,1262.28Z"
			/>
			<path
				className="cls-corp-mal-rep-9"
				d="M721,1262.28s-30.95-23.43-37.25-36,8.4-176.4,8.4-176.4l29.54-6.77s10.36,25.67,10.36,29.87-8.4,2.1-8.4,2.1,12.6,149.1,8.4,161.7A196,196,0,0,1,721,1262.28Z"
			/>
			<path
				className="cls-corp-mal-rep-2"
				d="M832.17,747.45c-6.3-29.4-18.9-81.9-18.9-98.7s-23.1-176.4-27.3-195.3-21-50.4-42-63-96.6-39.9-115.5-54.6c4.2-6.3,10.5-14.7,21-12.6s-8.4-31.5-31.5-33.6v39.9a9.2,9.2,0,0,0,2.1,6.3s-21,31.5-56.7,31.5-56.7-31.5-56.7-31.5a9.2,9.2,0,0,0,2.1-6.3v-39.9c-23.1,2.1-42,35.7-31.5,33.6s16.8,6.3,21,12.6c-18.9,14.7-94.5,42-115.5,54.6s-37.8,44.1-42,63-27.3,178.5-27.3,195.3-12.6,69.3-18.9,98.7-4.2,161.7,2.1,191.1c29.4,25.2,69.3,6.3,69.3,6.3s14.7-165.9,16.8-176.4,12.6-56.7,16.8-71.4S412.17,569,412.17,569s14.7,172.2,14.7,186.9-12.6,58.8-12.6,65.1c48.3,42,149.1,39.9,149.1,39.9s100.8,2.1,149.1-39.9c0-6.3-12.6-50.4-12.6-65.1S714.57,569,714.57,569s8.4,113.4,12.6,128.1,14.7,60.9,16.8,71.4,16.8,176.4,16.8,176.4,39.9,18.9,69.3-6.3C836.37,909.15,838.47,776.85,832.17,747.45Z"
			/>
			<g className="cls-corp-mal-rep-10">
				<path
					className="cls-corp-mal-rep-2"
					d="M832.17,747.45c-6.3-29.4-18.9-81.9-18.9-98.7s-23.1-176.4-27.3-195.3-21-50.4-42-63-96.6-39.9-115.5-54.6c4.2-6.3,10.5-14.7,21-12.6s-8.4-31.5-31.5-33.6v39.9a9.2,9.2,0,0,0,2.1,6.3s-21,31.5-56.7,31.5-56.7-31.5-56.7-31.5a9.2,9.2,0,0,0,2.1-6.3v-39.9c-23.1,2.1-42,35.7-31.5,33.6s16.8,6.3,21,12.6c-18.9,14.7-94.5,42-115.5,54.6s-37.8,44.1-42,63-27.3,178.5-27.3,195.3-12.6,69.3-18.9,98.7-4.2,161.7,2.1,191.1c29.4,25.2,69.3,6.3,69.3,6.3s14.7-165.9,16.8-176.4,12.6-56.7,16.8-71.4S412.17,569,412.17,569s14.7,172.2,14.7,186.9-12.6,58.8-12.6,65.1c48.3,42,149.1,39.9,149.1,39.9s100.8,2.1,149.1-39.9c0-6.3-12.6-50.4-12.6-65.1S714.57,569,714.57,569s8.4,113.4,12.6,128.1,14.7,60.9,16.8,71.4,16.8,176.4,16.8,176.4,39.9,18.9,69.3-6.3C836.37,909.15,838.47,776.85,832.17,747.45Z"
				/>
				<path
					className="cls-corp-mal-rep-11"
					d="M691.29,463.06c-35.22-11.71-127.92-11.71-127.92-11.71s-92.7,0-127.93,11.71,11.45-.05,31.52-2.93c20.39-2.92,64.89-5.85,96.41-5.85s76,2.93,96.41,5.85C679.84,463,726.52,474.77,691.29,463.06Z"
				/>
				<path
					className="cls-corp-mal-rep-12"
					d="M691.29,461c-35.22-11.71-127.92-11.71-127.92-11.71s-92.7,0-127.93,11.71,11.45,0,31.52-2.93c20.39-2.92,64.89-5.85,96.41-5.85s76,2.93,96.41,5.85C679.84,460.91,726.52,472.67,691.29,461Z"
				/>
				<rect
					className="cls-corp-mal-rep-13"
					x={561.27}
					y={415.65}
					width={4.2}
					height={445.2}
				/>
				<path
					className="cls-corp-mal-rep-14"
					d="M563.37,359s-42-23.1-46.55-11.56c20.65,11.54,46.55,72.46,46.55,72.46s25.89-60.92,46.54-72.46C605.37,335.85,563.37,359,563.37,359Z"
				/>
				<path
					className="cls-corp-mal-rep-11"
					d="M473.07,319.05s0-4.2,6.3-4.2c14.7,0,22.77,11.77,29.4,18.9s4.2-50.4,4.2-50.4L464.67,296Z"
				/>
				<path
					className="cls-corp-mal-rep-11"
					d="M654.1,319.05s0-4.2-6.3-4.2c-14.7,0-22.77,11.77-29.4,18.9s-4.2-50.4-4.2-50.4L662.5,296Z"
				/>
			</g>
		</g>
	</svg>
);
export default ClothesTechnicianMale;
